type Connection<Node> = {
  readonly edges: ReadonlyArray<{
    readonly node: Node | null;
  } | null> | null;
} | null;

export function extractNodes<Node>(
  conn: Connection<Node> | null | undefined
): Node[] {
  return (
    conn?.edges?.reduce((acc, edge) => {
      if (edge?.node) {
        return [...acc, edge.node];
      }

      return acc;
    }, [] as Node[]) ?? []
  );
}
